export default __webpack_public_path__ + "static/hs-0f51af04fc78ac27946d89ff28be3da4.mp4";